export const TVCHANNEL_BOUQUETS = 'BOUQUETS';
export const TVCHANNEL_CATEGORY = 'CATEGORY';
export const TVCHANNEL_CHANNELS = 'CHANNELS';
export const TVCHANNEL = 'tvchannel';

export const LANGUAGES = [
  {
    id: 'english',
    name: 'English',
  },
  {
    id: 'spanish',
    name: 'Spanish',
  },
  {
    id: 'french',
    name: 'French',
  },
  {
    id: 'arabic',
    name: 'Arabic',
  },
  {
    id: 'hindi',
    name: 'Hindi',
  },
  {
    id: 'chinese',
    name: 'Chinese',
  },
  {
    id: 'na',
    name: 'NA',
  },
];

export const CHANNEL_TYPE = [
  {
    id: 'dtv',
    name: 'DTV',
  },
  {
    id: 'sdtv',
    name: 'SDTV',
  },
  {
    id: 'cdtv',
    name: 'CDTV',
  },
];

export const CHANNEL_DRM = [
  {
    id: true,
    name: 'Yes',
  },
  {
    id: false,
    name: 'No',
  },
];

export const CHANNEL_FILTER_DATA = [
  {
    title: 'All',
    field: 'all',
    subMenu: [],
  },
  {
    title: 'Category',
    field: 'categoryName',
    subMenu: [],
  },
  {
    title: 'Language',
    field: 'language',
    subMenu: LANGUAGES,
  },
  {
    title: 'DRM',
    field: 'isDRM',
    subMenu: CHANNEL_DRM,
  },
];

export const TVCHANNEL_BOUQUETS_VIEW = 'tvchannel_bouquets_view';
export const TVCHANNEL_BOUQUETS_CREATE = 'tvchannel_bouquets_create';
export const TVCHANNEL_BOUQUETS_EDIT = 'tvchannel_bouquets_edit';
export const TVCHANNEL_CATEGORY_VIEW = 'category_view';
export const TVCHANNEL_CATEGORY_CREATE = 'category_create';
export const TVCHANNEL_CATEGORY_EDIT = 'category_edit';
export const TVCHANNEL_CHANNELS_VIEW = 'channels_view';
export const TVCHANNEL_CHANNELS_CREATE = 'channels_create';
export const TVCHANNEL_CHANNELS_EDIT = 'channels_edit';
export const TVCHANNEL_CHANNELS_TYPE = 'channels_typr';

export const TVCHANNEL_BOUQUETS_TABS = ['Details', 'Channels'];
export const TVCHANNEL_CHANNEL_TABS = ['Details', 'Media'];

export const CHANNEL_CSV_MAPPING = {
  name: 'Channel Name',
  code: 'Channel Code',
};
